<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Press Release</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Press Title"
                class="mb-0"
                type="text"
                disabled
                v-model="pressRelease.press_release_title"
                horizontal
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Press URL"
                class="mb-0"
                type="text"
                disabled
                v-model="pressRelease.press_release_url"
                horizontal
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              Image
              <img
                class="image-ilustrasi"
                id="myImg"
                v-if="pressRelease.attachment_press_release"
                :src="pressRelease.attachment_press_release"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                label="Content"
                class="mb-0"
                type="text"
                v-model="pressRelease.press_release_content"
                disabled
                horizontal
                placeholder
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="danger"
                class="float-right"
                @click="deletePressRelease"
                >Delete</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import jwt from "jsonwebtoken";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "PressReleaseDetail",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      pressRelease: {},
      delete: "true",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "COMMUNITY" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/about-us/press-release" });
    },
    getDataByID() {
      let pressReleaseID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/press_release/${pressReleaseID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.pressRelease = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    deletePressRelease() {
      let formData = new FormData();
      formData.append("is_delete", this.delete);
      let pressReleaseID = this.$route.params.id;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              `${this.domain}/v1/press_release/${pressReleaseID}`,
              formData,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              // JSON responses are automatically parsed.
              Swal.fire({
                icon: "success",
                title: `Press Release Data Deleted`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.items = response.data;
              this.$router.push({ path: `/about-us/press-release` });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err.response.data.message.id,
              });
              console.log(err);
            });
        }
      });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  },
};
</script>

<style scoped>
@import "./PressRelease.css";
</style>
